import React, { useEffect } from 'react';

import { track } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import { trackClick } from '../../features/track';
import Footer from '../../Shared/components/Footer';
import { MFA_LOCKED_SUPPORT_PHONE } from '../../Shared/constants';
import { urlBuilder } from '../../Shared/urlBuilder';

interface Props {
  title: string;
}

const SuspendedError: React.FC<React.PropsWithChildren<Props>> = ({ title }) => {
  useEffect(() => {
    track('ElementViewed', { name: 'Suspension', flow: 'OpenJointCheckingSecondary' });
  }, []);

  return (
    <CenteredWorkflowLayout title={title}>
      <CenteredWorkflowLayout.Slot name="content">
        <>
          <Box mb="8">
            <Icon name="ExclamationCircle" size="large" color="icon" />
          </Box>
          <Heading as="h1" fontSize={[5, 6]} mb="8">
            Your account is currently suspended
          </Heading>
          <Box mb="9">
            <Text as="p">You'll need to resolve the matter before you can open your Joint Checking account.</Text>
            <Text as="p">
              In order to do so, please respond to the email you received regarding the suspension. If you have not
              received an email, please call us at{' '}
              <a href={`tel:${MFA_LOCKED_SUPPORT_PHONE}`}>{MFA_LOCKED_SUPPORT_PHONE}</a> so we can assist you.
            </Text>
          </Box>
        </>
        <CenteredWorkflowLayout.Actions>
          <SambaAutoLink
            onClick={() => trackClick({ name: 'GotIt', flow: 'OpenJointCheckingSecondary' })}
            to={urlBuilder.appHome.absolute()}
            variant="solidPrimary"
          >
            Got it
          </SambaAutoLink>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};
export default SuspendedError;
